/* Thanks to CSS Tricks for pointing out this bit of jQuery
http://css-tricks.com/equal-height-blocks-in-rows/
It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */
// It has also been reduced to not care about rows and just make everything that is passed to it the same height

//  jQuery is a dependency but is usually included in the project already through CDN.
//      Uncomment the next line if you want jQuery to bundle.
// import $ from 'jquery'

export default function ($elements) {
  $elements.each(function () {
    var inner = $(this),
      container = inner.parent(),
      inHeight = inner.outerHeight(),
      conHeight = container.outerHeight(),
      conPadTop = parseInt(container.css('padding-top'), 10),
      conPadBot = parseInt(container.css('padding-bottom'), 10)
    // console.log(inHeight, conHeight, conPadTop, conPadBot)

    inner.css({'margin-top': ((conHeight - conPadTop - conPadBot) - inHeight) / 2 + 'px'})
  })
}
